import { memo } from 'react';

const read = (object, path) => path.split('.').reduce((value, key) => (value == null ? value : value[key]), object);

// The studio keys a set of components declared (undefined for a test double).
export const studioKeys = (...components) => components.flatMap(component => component?.studioKeys || []);

// `memo` for a component that takes the whole `studio` object. It renders again only when
// another prop changes, or when one of the `keys` changes: every `studio` field the component
// reads, plus those of the children it hands `studio` to (their own `studioKeys`). Keys are
// paths into `studio` ('snapshot.messages'); the Studio's actions keep their identity
// (useStableActions), so listing them is safe. Add a key whenever a read is added.
export default function memoStudio(Component, keys) {
  const watched = [...new Set(keys)];
  const Memo = memo(Component, (previous, next) => {
    const names = Object.keys(next);
    if (names.length !== Object.keys(previous).length) return false;
    for (const name of names) if (name !== 'studio' && previous[name] !== next[name]) return false;
    for (const key of watched) if (read(previous.studio, key) !== read(next.studio, key)) return false;
    return true;
  });
  Memo.studioKeys = watched;
  Memo.displayName = `memoStudio(${Component.displayName || Component.name || 'Component'})`;
  return Memo;
}
